export default "__VITE_ASSET__C_RG$sxI__"